import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { GlobalSearch } from '../../TCSMApp/global/components/navigation/global-search';


const searchBarMount = document.getElementById('search-bar');
const {
    placeHolderText,
} = (window as any).bootstrap;

if (searchBarMount) {


    ReactDOM.render(
        <GlobalSearch placeHolderText={placeHolderText} showResultsInTab={false} />
        , searchBarMount);
}
